import type { ChatListItemDto, ChatMessageRecommendationKey, JobImprovedDto } from './chat.dto';

import { getDictionary } from '@/shared/lib/i18n';

export type ChatListItemViewModel = {
  id: number;
  jobTitle: string;
  owner: string;
};

export type JobImprovedViewModel = {
  updatedAt: string;
};

export const toChatListItemViewModel = (dto: ChatListItemDto): ChatListItemViewModel => {
  return {
    id: dto.id,
    jobTitle: dto.job_title,
    owner: dto.user?.toString() || 'N/A',
  };
};

export const toJobImprovedViewModel = (dto: JobImprovedDto): JobImprovedViewModel => {
  return {
    updatedAt: dto.updated_at,
  };
};

export const recommendationKeyToLabel = (key: ChatMessageRecommendationKey) => {
  const dictionary = getDictionary();

  switch (key) {
    case 'job_title':
      return dictionary.jobTitle;
    case 'certificates':
      return dictionary.certificatesLabel;
    case 'key_responsibilities':
      return dictionary.keyResponsabilities;
    case 'requirements':
      return dictionary.jobRequirements;
    case 'salary_range':
      return dictionary.salaryRange;
    case 'salary_unit':
      return dictionary.salaryUnit;
    case 'working_hours_range':
      return dictionary.workingHours;
    case 'compensation_benefits':
      return dictionary.secondaryBenefits;
    case 'employment_type':
      return dictionary.employmentType;
    case 'shifts':
      return dictionary.shifts;
    case 'workdays':
      return dictionary.workdays;
    case 'education_level':
      return dictionary.educationLevel;
    case 'language':
      return dictionary.language;
    case 'language_level':
      return dictionary.languageLevel;
    case 'driver_license':
      return dictionary.driversLicense;
    default:
      return key;
  }
};
